import type { FaireProductEntity } from "../../entity_types/product";

export const p_9kn52guu3u: FaireProductEntity = {
  token: "p_9kn52guu3u",
  type: "product",
  name: "Minnesota 10K Treasures Seek & Find 550-Piece Puzzle",
  brandName: "Puzzles That Rock",
  imageUrl:
    "https://cdn.faire.com/fastly/3300727464e8de354b3b08be9bdcfff317bd648a66b55c580bebe73dbb97662a.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/05593792c198a113fb30bda0fca44648e592bd2ac08f892582755b5809691e23.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
